import "./styles.scss";
import Navbar from "./Components/Navbar";
import Main from "./Components/Main";
export default function App() {
	return (
		<>
			<Navbar />
			<Main />
		</>
	);
}
